import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

export default function CTA({
  primaryAction,
  primaryCaption,
  secondaryAction,
  secondaryCaption,
}) {
  return (
    <div className="etre-rappele-box">
      {secondaryAction && (
        <div>
          <button onClick={secondaryAction} className="creneau-btn">
            {secondaryCaption}
          </button>
        </div>
      )}
      {primaryAction && (
        <button
          className={clsx('btn-main-hoverlarge is-bold', {
            'w-full': !secondaryAction,
          })}
          style={{ cursor: 'pointer' }}
          onClick={primaryAction}
        >
          {primaryCaption}
        </button>
      )}
    </div>
  );
}
CTA.propTypes = {
  primaryAction: PropTypes.func,
  primaryCaption: PropTypes.string,
  secondaryAction: PropTypes.func,
  secondaryCaption: PropTypes.string,
};
